const baseURL = process.env.VUE_APP_API_URL;

const getStepUrl = (type, id) => {
    return baseURL + 'download-stp/' + type + '/' + id;
};

export { getStepUrl }
